import {
  CREATEPRODUCTORDERS,
  DELETEPRODUCTORDERS,
  GETPRODUCTORDERS,
  UPDATEPRODUCTORDERS,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEPRODUCTORDERS:
      return {
        ...state,
        productordersSaveStatus: action.payload.success,
      };
    case GETPRODUCTORDERS:
      return {
        ...state,
        productordersList: action.payload.data,
      };
    case UPDATEPRODUCTORDERS:
      return {
        ...state,
        productordersUpdateStatus: action.payload.success,
      };

    case DELETEPRODUCTORDERS:
      return {
        ...state,
        productordersDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
